import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import mixin from './mixins'
import './plugins/element-ui'

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.mixin(mixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
